import React, { useState } from 'react';
import '../App.css'; // Changed from './App.css' to '../App.css'

const Courses = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const courses = [
    // {
    //   class: 'Class 9',
    //   duration: '10 months *',
    //   mode: 'Online & Offline',
    //   batch: 'Regular & Weekend',
    //   icon: '🎯',
    //   gradient: 'linear-gradient(135deg, #64b3ecff 0%, #7a9fd7ff 100%)',
    //   features: ['Basic Concepts', 'Foundation Building', 'Practical Approach']
    // },
    // {
    //   class: 'Class 10',
    //   duration: '10 months *',
    //   mode: 'Online & Offline',
    //   batch: 'Regular & Weekend',
    //   icon: '🚀',
    //   gradient: 'linear-gradient(135deg, #c953d6ff 0%, #e4b8beff 100%)',
    //   features: ['Board Preparation', 'Revision Strategy', 'Sample Papers']
    // },
    {
      class: 'Class 11',
      duration: '12 months *',
      mode: 'Online & Offline',
      batch: 'Regular & Weekend',
      icon: '🔬',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      features: ['Advanced Topics', 'Lab Work', 'Concept Depth']
    },
    {
      class: 'Class 12',
      duration: '12 months *',
      mode: 'Online & Offline',
      batch: 'Regular & Weekend',
      icon: '🏆',
      gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
      features: ['Board Focus', 'Competitive Edge', 'Full Syllabus']
    }
  ];
  const openWhatsApp = () => {
    const message = "Hello! I'm interested in Chemistry tuition for CBSE classes. Could you please provide more information? (via © srichemtution.com)";
    const phone = "+919790885125";
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank');
  };
  const scrollToForm = () => {
    document.getElementById('enquiry-form').scrollIntoView({
      behavior: 'smooth'
    });
  };

  return (
    <section id="courses" className="section courses-section">
      <div className="container">
        <h2 className="section-title">Our Courses</h2>
        <p className="section-subtitle">
          Specialized Chemistry Tuition for CBSE Curriculum - Building Strong Foundations
        </p>

        <div className="courses-grid">
          {courses.map((course, index) => (
            <div
              key={index}
              className="course-card"
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
              style={{
                transform: hoveredCard === index ? 'translateY(-12px) scale(1.02)' : 'translateY(0) scale(1)',
                background: hoveredCard === index ? course.gradient : 'white',
                color: hoveredCard === index ? 'white' : 'inherit',
                transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
              }}
            >
              {/* Course Header with Icon */}
              <div className="card-header">
                <div className="course-icon-header">
                  <div
                    className="course-icon"
                    style={{
                      background: hoveredCard === index ? 'rgba(255,255,255,0.2)' : 'rgba(102, 126, 234, 0.1)',
                      color: hoveredCard === index ? 'white' : '#667eea'
                    }}
                  >
                    {course.icon}
                  </div>
                  <div>
                    <h3>{course.class}</h3>
                    <div className="class-badge">CBSE</div>
                  </div>
                </div>
              </div>

              {/* Course Features */}
              <div className="course-features">
                <div className="feature-item">
                  <span className="feature-label">Duration:</span>
                  <span className="feature-value">{course.duration}</span>
                </div>
                <div className="feature-item">
                  <span className="feature-label">Mode:</span>
                  <span className="feature-value">{course.mode}</span>
                </div>
                <div className="feature-item">
                  <span className="feature-label">Batch:</span>
                  <span className="feature-value">{course.batch}</span>
                </div>
              </div>


            </div>
          ))}
        </div>

        {/* Footer Note and CTA */}
        <div className="courses-footer">
          <p className="duration-note">* Actual course duration is subjected to variations</p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap' }}>
            <button
              className="btn btn-primary main-cta-btn"
              onClick={scrollToForm}
            >
              Enquire now
            </button>
            <button className="btn whatsapp-btn main-cta-btn" onClick={openWhatsApp}>
              <i className="fa-brands fa-whatsapp"></i>
              <span> WhatsApp Now</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Courses;